import { Link } from "react-router-dom";
import Button from "./ui/Button";
import Card from "./ui/Card";

const variantClasses = {
  info: "border-hookd-empress/40 bg-hookd-empress/10 text-hookd-cream",
  warning: "border-hookd-gold/45 bg-hookd-gold/10 text-hookd-cream",
  error: "border-hookd-neon/45 bg-hookd-neon/10 text-hookd-cream",
};

export default function RecoveryPanel({
  title,
  message,
  actions = [],
  variant = "error",
}) {
  const className = variantClasses[variant] || variantClasses.error;

  return (
    <Card className={`p-5 ${className}`} role="alert">
      {title && <h3 className="font-display text-2xl font-bold mb-2">{title}</h3>}
      {message && <p className="text-sm leading-6 text-hookd-muted mb-4">{message}</p>}
      {actions.length > 0 && (
        <div className="grid gap-3 sm:flex sm:flex-wrap">
          {actions.map((action) =>
            action.to ? (
              <Button
                as={Link}
                key={action.label}
                to={action.to}
                variant="primary"
                className="w-full sm:w-auto"
              >
                {action.label}
              </Button>
            ) : (
              <Button
                key={action.label}
                type="button"
                onClick={action.onClick}
                disabled={action.disabled}
                variant="outline"
                className="w-full sm:w-auto"
              >
                {action.label}
              </Button>
            )
          )}
        </div>
      )}
    </Card>
  );
}
